import React from 'react';
import ReactDOM from "react-dom/client";
import App from "./App";

ReactDOM.createRoot(
	document.getElementById("admin-order-sms") as Element,
).render(
	<React.StrictMode>
		<App />
	</React.StrictMode>,
);